export const isFirefox = () => navigator.userAgent.indexOf('Firefox') > -1;
export default isFirefox;
